export enum PageDataMode {
  standBy = 'standBy',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}

export type PageDataState<TParams, TData> =
  | { mode: PageDataMode.standBy }
  | { mode: PageDataMode.loading; dataParams: TParams }
  | { mode: PageDataMode.loaded; dataParams: TParams; data: TData }
  | { mode: PageDataMode.error; dataParams: TParams };
